import { Link } from "react-router-dom";
import { ArrowRight, Calculator as CalcIcon } from "lucide-react";
import { Card } from "@/components/ui/card";
import Reveal from "@/components/layout/Reveal";
import SectionLabel from "@/components/layout/SectionLabel";

export const CalculatorPreviewSection = () => {
  return (
    <section className="py-20 sm:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6 sm:px-8">
        <Reveal>
          <Card className="rounded-3xl border-[#E2E8F0] p-8 sm:p-12 bg-gradient-to-br from-white to-[#F8FAFC]">
            <div className="grid md:grid-cols-2 gap-10 items-center">
              <div>
                <SectionLabel>Savings Calculator</SectionLabel>
                <h2 className="font-heading mt-4 text-3xl sm:text-4xl font-bold text-[#0B132B]">
                  See what you could save — in under 2 minutes.
                </h2>
                <p className="mt-4 text-[#475569] leading-relaxed">
                  Based on your household size, showers per day, current system, gas price and electricity tariff. Transparent assumptions. No guesswork.
                </p>
                <Link
                  to="/savings-calculator"
                  data-testid="calc-preview-cta"
                  className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#10B981] hover:bg-[#059669] text-white px-6 py-3.5 font-semibold transition-all hover:shadow-lg hover:shadow-emerald-500/30 active:scale-95"
                >
                  <CalcIcon className="h-4 w-4" />
                  Calculate My Estimate
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {[
                  { label: "Annual saving", val: "$1,100+" },
                  { label: "15-yr saving", val: "$16,500+" },
                  { label: "CO₂ reduced", val: "1.2t/yr" },
                  { label: "Confidence", val: "High" },
                ].map((s, i) => (
                  <div key={i} className="rounded-2xl border border-[#E2E8F0] p-5 bg-white">
                    <p className="text-[10px] uppercase tracking-widest text-[#475569] font-semibold">{s.label}</p>
                    <p className="font-heading text-2xl font-bold text-[#0B132B] mt-1 num-tab">{s.val}</p>
                  </div>
                ))}
              </div>
            </div>
          </Card>
        </Reveal>
      </div>
    </section>
  );
};
